import { IArea } from 'interfaces/areas'

export const getAreasData = (parentId = 0, accumulator = [] as any, dataSource: IArea[]): IArea[] => {
  const result = accumulator
  if (result.length < 3 && parentId) {
    const parent = dataSource.find(({ id }: IArea) => id === parentId)
    if (parent) {
      result.push(parent)
      parent.parentId && getAreasData(parent.parentId, result, dataSource)
    }
  }
  return result
}
